"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericImageHero = exports.heroTextColorVariants = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useWindowSize_1 = __importDefault(require("../hooks/useWindowSize"));
exports.heroTextColorVariants = {
    light: 'text-gray-e',
    dark: 'text-gray',
};
// Min height for banner in px;
const MIN_HEIGHT_CLASS = `min-h-[360px]`;
function GenericImageHero(_a) {
    var { className, title, hideTitle, backgroundImageURL, mobileBackgroundImageURL, mobileBreakpoint = 720, backgroundColor, centerImage, centerImageAltText, textColor = 'light', enableMinHeight = false, componentName, subtext, hideSubtext, darkText, children } = _a, props = __rest(_a, ["className", "title", "hideTitle", "backgroundImageURL", "mobileBackgroundImageURL", "mobileBreakpoint", "backgroundColor", "centerImage", "centerImageAltText", "textColor", "enableMinHeight", "componentName", "subtext", "hideSubtext", "darkText", "children"]);
    const { width } = (0, useWindowSize_1.default)();
    const isMobile = width && width < mobileBreakpoint;
    return (react_1.default.createElement("div", Object.assign({ className: "bg-cover bg-center bg-no-repeat", style: {
            backgroundImage: `url(${isMobile && mobileBackgroundImageURL
                ? mobileBackgroundImageURL
                : backgroundImageURL})`,
            backgroundColor: backgroundColor ? backgroundColor : 'transparent',
        } }, props),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('relative w-full flex justify-center items-center overflow-hidden text-center py-6 px-4 max-w-[1440px] mx-auto', exports.heroTextColorVariants[textColor], { [MIN_HEIGHT_CLASS]: enableMinHeight }) },
            react_1.default.createElement("div", { className: "flex flex-col w-full" },
                centerImage && (react_1.default.createElement("img", { src: centerImage, alt: centerImageAltText, className: "block max-w-full h-auto mx-auto my-4" })),
                children))));
}
exports.GenericImageHero = GenericImageHero;
